<template>
    <div>
        <div class="py-10 mb-10">
            <div class="col-sm-6 col-xl-4">
                <button
                    @click.prevent="showModal"
                    type="button"
                    class="btn mybtn btn-rounded  min-width-125"
                    data-toggle="click-ripple"
                    style="overflow: hidden; position: relative; z-index: 1;"
                >
                    <i class="si si-credit-card"></i>
                    Card Request
                </button>
            </div>
        </div>

        <div class="row">
            <div class="block-content">
                <div class="col-sm-12 table-responsive">
                    <table class="table table-striped table-vcenter">
                        <thead>
                            <tr role="row">
                                <th class="text-center" tabindex="0">
                                    #
                                </th>
                                <th class="text-capitalize">
                                    Email
                                </th>
                                <th class="text-capitalize">
                                    Fullname
                                </th>

                                <th class="text-capitalize">
                                    Type
                                </th>
                                <th class="text-capitalize">
                                    Model
                                </th>
                                <th class="text-capitalize">
                                    Number
                                </th>
                                <th class="text-capitalize">
                                    CVV
                                </th>
                                <th class="text-capitalize">
                                    Expiry
                                </th>
                                <th class="text-capitalize">
                                    Status
                                </th>

                                <th class="text-center text-capitalize">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                role="row"
                                class="odd"
                                v-for="(card, index) in cards"
                            >
                                <td class="text-center sorting_1">
                                    {{ index + 1 }}
                                </td>
                                <td>
                                    {{ card.email }}
                                </td>
                                <td>
                                    {{ card.name }}
                                </td>
                                <td>
                                    {{ card.card_type }}
                                </td>
                                <td>
                                    {{ card.card_model }}
                                </td>
                                <td>
                                    {{
                                        card.status
                                            ? card.number
                                                  .replace(/[^\dA-Z]/g, "")
                                                  .replace(/(.{4})/g, "$1 ")
                                                  .trim()
                                            : "Unavailable"
                                    }}
                                </td>
                                <td>
                                    {{ card.status ? card.cvv : "Unavailable" }}
                                </td>
                                <td>
                                    {{
                                        card.status
                                            ? card.expires
                                            : "Unavailable"
                                    }}
                                </td>
                                <td>
                                    <span
                                        class="text-warning"
                                        v-if="card.status == 0"
                                        >Pending</span
                                    >
                                    <span class="text-success" v-else
                                        >Success</span
                                    >
                                </td>

                                <td>
                                    <div class="btn-group">
                                        <button
                                            v-if="card.status"
                                            type="button"
                                            class="btn btn-sm btn-success mr-2"
                                            data-toggle="tooltip"
                                            title="Edit"
                                            @click.prevent="viewCard(card)"
                                        >
                                            View Card
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- card request modal -->
        <div
            class="modal fade"
            id="modal-invest"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-popin"
            style="display: none;"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-popin"
                role="document"
            >
                <div class="modal-content">
                    <div class="block block-transparent mb-0">
                        <div class="block-header">
                            <h3 class="block-title">
                                New card request
                            </h3>
                            <div class="block-options">
                                <button
                                    type="button"
                                    class="btn-block-option"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i class="si si-close"></i>
                                </button>
                            </div>
                        </div>
                        <div class="block-content">
                            <form @submit.prevent="requestCard">
                                <div class="modal-body">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Card Type</label
                                                    >

                                                    <select
                                                        name="trans_option"
                                                        id="card_type"
                                                        class="form-control"
                                                        required
                                                        v-model="card_type"
                                                    >
                                                        <option
                                                            value="Debit Card"
                                                            selected
                                                            >Debit Card
                                                        </option>
                                                        <option
                                                            value="Credit Card"
                                                            selected
                                                            >Credit Card
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col-lg-12">
                                                    <label for="account"
                                                        >Card Model</label
                                                    >
                                                    <select
                                                        v-model="card_model"
                                                        name="type"
                                                        class="form-control"
                                                        required=""
                                                    >
                                                        <option value=""
                                                            >Select card
                                                            type</option
                                                        >
                                                        <option
                                                            value="Visa Card"
                                                            >Visa Card
                                                        </option>
                                                        <option
                                                            value="Master Card"
                                                            >Master Card
                                                        </option>
                                                        <option
                                                            value="American Express"
                                                            >American Express
                                                        </option>
                                                        <option value="Discover"
                                                            >Discover
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <div
                                                    v-if="processing"
                                                    class="col-6 col-md-3"
                                                >
                                                    <i
                                                        class="fa fa-2x fa-cog fa-spin text-primary"
                                                    ></i>
                                                </div>
                                                <div class="col-md-9" v-else>
                                                    <button
                                                        type="submit"
                                                        class="btn btn-danger mb-2"
                                                    >
                                                        Request Card
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end of card request  modal -->

        <!-- card request modal -->
        <div
            class="modal fade"
            id="modal-card"
            tabindex="-1"
            role="dialog"
            aria-labelledby="modal-popin"
            style="display: none;"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-popin"
                role="document"
            >
                <div class="modal-content">
                    <div>
                        <creditCard :card="currentCard" style="width: 65%" />
                    </div>
                </div>
            </div>
        </div>
        <!-- end of card request  modal -->
    </div>
</template>
<script>
import { RepositoryFactory as Repo } from "../../repository/RepositoryFactory";
import CreditCard from "../../components/Card";
const AR = Repo.get("users");
export default {
    components: { CreditCard },
    data() {
        return {
            investType: this.$route.params.type,
            cards: [],
            processing: false,
            currentPlan: {},
            account_type: null,
            account: null,
            card_model: "Visa Card",
            card_type: "Debit Card",
            currentCard: {}
        };
    },
    methods: {
        viewCard(card) {
            this.currentCard = card;
            $("#modal-card").modal("show");
        },
        showModal() {
            $("#modal-invest").modal("show");
        },
        async requestCard() {
            this.processing = true;
            let data = {
                card_model: this.card_model,
                card_type: this.card_type
            };
            try {
                await AR.usercard(data);
                $("#modal-invest").modal("hide");
                this.processing = false;
                toast.fire({
                    type: "success",
                    title: "Card request has been sent successfully"
                });
            } catch (error) {
                this.processing = false;

                console.log(error);
            }
        },
        async loadCards() {
            try {
                let res = await AR.userFetchCards();
                this.cards = res.data;
            } catch (error) {
                console.log(error);
            }
        }
    },
    created() {
        AR.loggedInUser().then(response => {
            this.user = response.data;
        });
        this.loadCards();
    }
};
</script>
